<template>
  <div>
    <el-dialog
      :title="addAndEditData.title"
      :visible.sync="addAndEditData.show"
      center
      width="700px"
    >
      <el-form :model="formData" label-width="135px">
        <el-form-item :label="$t('PlatformCurrency')">
          <el-input
            disabled
            v-model="formData.PSymbol"
            :placeholder="$t('PlatformCurrency')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('transactionCurrency')">
          <el-select
            v-model="formData.Symbol"
            disabled
            :placeholder="$t('transactionCurrency')"
            clearable
          >
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('depositExchangeRateDeviationPlanning')">
          <el-radio
            v-model="formData.RechargeFixType"
            @input="inputRechargeFixType"
            :label="1"
            >{{ $t('Eigenvalue') }}</el-radio
          >
          <el-radio
            v-model="formData.RechargeFixType"
            @input="inputRechargeFixType"
            :label="2"
            >{{ $t('percentage') }}</el-radio
          >
        </el-form-item>
        <el-form-item :label="$t('depositExchangeRateDiscrepancy')">
          <div style="display: flex; align-items: center">
            <el-input
              style="margin-right: 5px"
              v-model="formData.RechargeFix"
              :placeholder="$t('depositExchangeRateDiscrepancy')"
            ></el-input>
            <el-tooltip effect="dark" placement="top">
              <div slot="content" style="text-align: center">
                充值的话，为交易币种→平台币种，而交易的汇率是
                平台币种:交易币种，<br />所以充值交易的汇率 = 即时汇率 + 偏差值
              </div>
              <span class="el-icon-question"></span>
            </el-tooltip>
          </div>
        </el-form-item>
        <el-form-item :label="$t('WithdrawalRateDeviationRules')">
          <el-radio
            v-model="formData.WithwardFixType"
            @input="inputWithwardFixType"
            :label="1"
            >{{ $t('Eigenvalue') }}</el-radio
          >
          <el-radio
            v-model="formData.WithwardFixType"
            @input="inputWithwardFixType"
            :label="2"
            >{{ $t('percentage') }}</el-radio
          >
        </el-form-item>
        <el-form-item :label="$t('withdrawalExchangeRateDeviation')">
          <div style="display: flex; align-items: center">
            <el-input
              style="margin-right: 5px"
              v-model="formData.WithwardFix"
              :placeholder="$t('withdrawalExchangeRateDeviation')"
            ></el-input>
            <el-tooltip effect="dark" placement="top">
              <div slot="content" style="text-align: center">
                充值的话，为交易币种→平台币种，而交易的汇率是
                平台币种:交易币种，<br />所以提现交易的汇率 = 即时汇率 - 偏差值
              </div>
              <span class="el-icon-question"></span>
            </el-tooltip>
          </div>
        </el-form-item>
        <el-form-item label="充值最小值" v-if="addAndEditData.data.FType == 2">
          <el-input
            v-model="formData.RechargeMin"
            :placeholder="$t('depositRange')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('withdrawalRange')" v-if="addAndEditData.data.FType == 2">
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="formData.WithwardMin"
                :placeholder="$t('withdrawalRange')"
              ></el-input>
            </el-col>
            <el-col :span="2" style="text-align: center">
              <span>-</span>
            </el-col>
            <el-col :span="11">
              <el-input
                v-model="formData.WithwardMax"
                :placeholder="$t('withdrawalRange')"
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('manualRechargeRateSetting')">
          <el-row>
            <el-col>
              <el-input
                v-model="formData.RechargeRateEx"
                :placeholder="$t('manualRechargeRateSetting')"
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('manualWithdrawalRateSetting')">
          <el-row>
            <el-col>
              <el-input
                v-model="formData.WithwardRateEx"
                :placeholder="$t('manualWithdrawalRateSetting')"
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="$t('Status')">
          <el-select v-model="formData.State"  :placeholder="$t('Status')" clearable>
            <el-option :label="$t('Enable')" :value="1"> </el-option>
            <el-option :label="$t('deactivate')" :value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('AutomaticExchangeRate')">
          <el-select
            v-model="formData.AutoState"
            :placeholder="$t('AutomaticExchangeRate')"
            clearable
          >
            <el-option :label="$t('Open')" :value="1"> </el-option>
            <el-option :label="$t('TurnOff')" :value="2"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('networkProtocol')" v-if="addAndEditData.data.FType == 2">
          <el-table
            row-key="Net"
            id="sortTable"
            :data="tableData"
            border
            :cell-style="{ padding: '1' }"
          >
            <el-table-column
              align="center"
              prop="Net"
              :label="$t('Network')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="TradeTime"
              :label="$t('transactionTime')"
            ></el-table-column>
            <el-table-column align="center" prop="State" :label="$t('Status')">
              <template slot-scope="scope">
                <span v-if="scope.row.State == 1">{{$t('Open')}}</span>
                <span v-else>{{$t('TurnOff')}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center"  :label="$t('Actions')">
              <template slot-scope="scope">
                <el-button type="text" @click="editNet(scope.row, scope.$index)"
                  >{{$t('Edit')}}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item :label="$t('Sorting')">
          <el-input v-model="formData.Sort":placeholder="$t('Sorting')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('showOnHomePage')">
          <el-radio v-model="formData.ShowIndex" :label="1">{{$t('Yes')}}</el-radio>
          <el-radio v-model="formData.ShowIndex" :label="2">{{$t('No')}}</el-radio>
        </el-form-item>
        <el-form-item :label="$t('icon')">
          <el-upload
            class="avatar-uploader"
            :action="this.$global.baseURL + '/upload'"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :headers="{ 'x-token': token }"
          >
            <img
              v-if="imageUrl"
              :src="`${baseurl}${imageUrl}`"
              class="avatar"
              width="50"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('coldWalletAddress')" v-if="formData.Symbol == 'TON'">
          <el-input
            v-model="formData.ColdWallet"
            :placeholder="$t('coldWalletAddress')"
          ></el-input>
        </el-form-item>
        <el-form-item  :label="$t('GoogleVerificationCode')">
          <el-input
            v-model="formData.GoogleCode"
           :placeholder="$t('GoogleVerificationCode')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">{{$t('Confirm2')}}</el-button>
      </span>
    </el-dialog>
    <!-- 编辑网络 -->
    <el-dialog :title="$t('Edit')" :visible.sync="showNet" center width="300px">
      <el-form :model="netForm" label-width="75px">
        <el-form-item :label="$t('Network')">
          <el-input
            disabled
            v-model="netForm.Net"
            placeholder="网络"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('transactionTime')">
          <el-input
            type="number"
            v-model="netForm.TradeTime"
            :placeholder="$t('transactionTime')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('Status')">
          <el-select v-model="netForm.State"  :placeholder="$t('Status')" clearable>
            <el-option :label="$t('Open')" :value="1"> </el-option>
            <el-option :label="$t('TurnOff')" :value="2"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitNet">{{$t('Confirm2')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
  props: {
    addAndEditData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {
        RateSource: "",
        PSymbol: "",
        Symbol: "",
        RechargeFixType: "",
        RechargeFix: "",
        WithwardFixType: "",
        WithwardFix: "",
        AutoState: "",
        State: "",
        GoogleCode: "",
        Icon: "",
        Sort: "",
        MinRecharge: "",
        MaxRecharge: "",
        MinWithdraw: "",
        MaxWithdraw: "",
        RechargeRateEx: "",
        RechargeMin: "",
        RechargeMax: "",
        WithwardMin: "",
        WithwardMax: "",
        WithwardRateEx: "",
        ShowIndex: "",
        NetJson: "",
        SellerId: "",
        ColdWallet: "",
      },
      imageUrl: "",
      token: sessionStorage.getItem("token"),
      baseurl: "",
      tableData: [],
      showNet: false,
      netForm: {
        Net: "",
        TradeTime: "",
        State: "",
      },
      netRowIndex: "",
    };
  },
  created() {
    this.formData.SellerId = this.addAndEditData.data.SellerId;
    this.formData.RateSource = this.addAndEditData.data.RateSource;
    this.formData.PSymbol = this.addAndEditData.data.PSymbol;
    this.formData.Symbol = this.addAndEditData.data.Symbol;
    this.formData.RechargeFixType = this.addAndEditData.data.RechargeFixType;
    this.formData.RechargeFix =
      this.addAndEditData.data.RechargeFixType == 1
        ? this.addAndEditData.data.RechargeFix
        : Math.round(this.addAndEditData.data.RechargeFix * 10000000) / 100000;
    this.formData.WithwardFixType = this.addAndEditData.data.WithwardFixType;
    this.formData.WithwardFix =
      this.addAndEditData.data.WithwardFixType == 1
        ? this.addAndEditData.data.WithwardFix
        : Math.round(this.addAndEditData.data.WithwardFix * 10000000) / 100000;
    this.formData.State = this.addAndEditData.data.State;
    this.formData.AutoState = this.addAndEditData.data.AutoState;
    this.baseurl = this.addAndEditData.baseurl;
    this.imageUrl = this.addAndEditData.data.Icon;
    this.formData.Icon = this.addAndEditData.data.Icon;
    this.formData.Sort = this.addAndEditData.data.Sort;
    this.formData.RechargeMin = this.addAndEditData.data.RechargeMin;
    this.formData.RechargeMax = this.addAndEditData.data.RechargeMax;
    this.formData.WithwardMin = this.addAndEditData.data.WithwardMin;
    this.formData.WithwardMax = this.addAndEditData.data.WithwardMax;
    this.formData.RechargeRateEx = this.addAndEditData.data.RechargeRateEx;
    this.formData.WithwardRateEx = this.addAndEditData.data.WithwardRateEx;
    this.formData.ShowIndex = this.addAndEditData.data.ShowIndex;
    // this.formData.ColdWallet = this.addAndEditData.data.ColdWallet
    this.tableData = this.addAndEditData.data.NetJson
      ? JSON.parse(this.addAndEditData.data.NetJson)
      : [];
  },
  mounted() {
    if (this.addAndEditData.data.FType == 2) {
      this.$nextTick(() => {
        this.initSort();
      });
    }
  },
  methods: {
    // 编辑网络
    editNet(row, index) {
      this.showNet = true;
      this.netForm.Net = row.Net;
      this.netForm.TradeTime = row.TradeTime;
      this.netForm.State = row.State;
      this.netRowIndex = index;
    },
    // 编辑网络确认
    submitNet() {
      this.tableData[this.netRowIndex].Net = this.netForm.Net;
      this.tableData[this.netRowIndex].TradeTime = this.netForm.TradeTime;
      this.tableData[this.netRowIndex].State = this.netForm.State;
      this.showNet = false;
    },
    initSort() {
      const el = document.querySelector(
        "#sortTable .el-table__body-wrapper > table > tbody"
      );
      new Sortable(el, {
        onEnd: (evt) => {
          const currRow = this.tableData.splice(evt.oldIndex, 1)[0];
          this.tableData.splice(evt.newIndex, 0, currRow);
        },
      });
    },
    inputRechargeFixType(val) {
      this.formData.RechargeFix = "";
    },
    inputWithwardFixType(val) {
      this.formData.WithwardFix = "";
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.data.filename;
      this.formData.Icon = this.imageUrl;
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "image/webp";
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG/webp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isJPG && isLt2M;
    },
    submit() {
      if (this.formData.Symbol == "TRX") {
        if (
          this.formData.RechargeRateEx &&
          (this.formData.RechargeRateEx < 0.01 ||
            this.formData.RechargeRateEx > 0.5)
        ) {
          this.formData.RechargeRateEx = "";
          return this.$message.warning("TRX手动设置充值汇率区间为 0.01-0.5");
        }
        if (
          this.formData.WithwardRateEx &&
          (this.formData.WithwardRateEx < 0.01 ||
            this.formData.WithwardRateEx > 0.5)
        ) {
          this.formData.WithwardRateEx = "";
          return this.$message.warning("TRX 手动设置提款汇率区间为 0.01-0.5");
        }
      }
      if (this.formData.Symbol == "USDT") {
        if (
          this.formData.RechargeRateEx &&
          (this.formData.RechargeRateEx < 0.1 ||
            this.formData.RechargeRateEx > 1)
        ) {
          this.formData.RechargeRateEx = "";
          return this.$message.warning("USDT手动设置提款汇率区间为 0.1-1");
        }
        if (
          this.formData.WithwardRateEx &&
          (this.formData.WithwardRateEx < 0.1 ||
            this.formData.WithwardRateEx > 1)
        ) {
          this.formData.WithwardRateEx = "";
          return this.$message.warning("USDT手动设置提款汇率区间为 0.1-1");
        }
      }
      this.formData.NetJson = JSON.stringify(this.tableData);
      this.$emit("submitAddAndEditData", this.formData);
    },
  },
};
</script>

<style scoped>
::v-deep .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px !important;
  height: 70px !important;
  line-height: 70px !important;
  text-align: center;
}

::v-deep .avatar {
  width: 70px !important;
  height: 70px !important;
  display: block;
}

::v-deep .el-upload--text {
  width: 70px !important;
  height: 70px !important;
}
</style>
